import { render } from "./ContactViewUnauthorized.vue?vue&type=template&id=2321812a"
import script from "./ContactViewUnauthorized.vue?vue&type=script&lang=js"
export * from "./ContactViewUnauthorized.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__